import React, { useState, useEffect, useContext } from "react";
// import ChannelBoxProps from "../../Create_channel/Empty_Screen/Channels_List/ChannelBoxProps";
import PostImage from "../total_community_post/recent_post Img/PostImage";
import "./feedDetail.css";
import Form from "react-bootstrap/Form";
import CreateChannelFirst from "../../Create_channel/Create_channel_screen/CreateChannelFirst";
import CommentList from "./CommentList";
import axios from "../../../axios";
import { Link, useLocation } from "react-router-dom";

import ChannelBox from "../../Create_channel/Empty_Screen/Channels_List/ChannelBox";
import { useSelector } from "react-redux";
import CreatePostFirst from "../Create_Post_screen/CreatePostFirst";
import HeaderContext from "../../../HeaderContext";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import CommunityTour from "../../../SidebarHeader/Header/CommunityTour";
import {
  engagementHomeSteps,
  feelDetailSteps,
} from "../../../utils/engagementSteps";
import PostImagePopup from "./PostImagePopup";
// import axios from "../../../axios";

const FeedDetail = ({ post_id, commentLength }) => {
  const [viewFirstInProgress, setViewFirstInProgress] = useState(false);
  const [active, setActive] = useState("About");
  const [clickCreate, setClickCreate] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [isCommented, setIsCommented] = useState(false);
  const [commentAttach, setCommentAttach] = useState(null);
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  const [commentDeleted, setCommentDeleted] = useState(false);
  const [currentCommentNumber, setCurrentCommentNumber] = useState(0);
  const [areMoreComments, setAreMoreComments] = useState(true);
  const [selectedCommunity, setSelectedCommunity] = useState();
  const [postCreatedCount, setPostCreatedCount] = useState(0);
  const [allPost, setAllPost] = useState([]);
  const [visibleComments, setVisibleComments] = useState(5);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 6,
  });
  const { page, limit } = filter;
  const currentUser = useSelector((state) => state.user.currentUser);
  const { state } = useLocation()
  const [postCommeCommu, setPostCommeCommu] = useState({
    postByIds: {},
    communitys: {},
  });
  const { postByIds, communitys } = postCommeCommu;
  const [isPostCreated, setIsPostCreated] = useState(false);
  const [clickPost, setClickPost] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  const [steps, setSteps] = useState(feelDetailSteps);
  const onExit = () => {
    setStepsEnabled(false);
  };
  const { handleProfile } = useContext(HeaderContext);
  const StudentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const { countComment, setCommentCount } = useContext(HeaderContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPostCreated(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [isPostCreated]);

  useEffect(() => {
    const getPostCommeCommu = async () => {
      try {
        const postByIds = await axios.get(`/community/post/get/${post_id}`);
        const communitys = await axios.get(
          `/community/getByUserId/student/${currentUser?.id}`
        );

        postByIds &&
          communitys &&
          setPostCommeCommu({
            postByIds: postByIds.data.data,
            communitys: communitys.data.data,
          });
      } catch (error) { }
    };
    getPostCommeCommu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post_id]);

  useEffect(() => {
    getPostComme();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post_id, commentDeleted]);

  //update logic for refresh community comments
  const getPostComme = async () => {
    try {
      setIsInProgress(true);
      const res = await axios.get(
        `/community/post/${post_id}/comment/get?sortBy=-1`
      );
      let data = [];
      res.data.data.map((posts) => {
        if (posts.isDeleted) {
          if (StudentData?.id === posts?.user_id?.id) {
            data.push(posts)
          }
        } else {
          data?.push(posts)
        }
      })

      res && setComments((prev) => [...prev, ...data]);
      setIsInProgress(false);

    } catch (error) {
      console.log("error", error)
    } finally {
      setIsInProgress(false);
    }

  };


  const handelComment = async (e) => {
    setIsInProgress(true);
    e.preventDefault();
    let newComment = {
      user_id: currentUser?.id,
      comment,
    };
    if (commentAttach) {
      const formData = new FormData();
      formData.append("name", commentAttach.name);
      formData.append("uploadfile", commentAttach);
      try {
        const res = await axios.post(
          `/community/post/comment/upload`,
          formData
        );
        newComment.attachments = res.data.data;
      } catch (error) { }
    }
    try {
      const res = await axios.post(
        `/community/post/${post_id}/comment/create`,
        newComment
      );

      if (res) {
        setIsInProgress(!isInProgress);
        setIsCommented(!isCommented);
        setComment("");
        setCommentAttach(null);
        setFilter({ ...filter, page: 1 });
        setComments([]);
        await getPostComme();
        window.scrollTo(0, scrollY);
        // setCurrentCommentNumber(comments.length);
        setIsInProgress(false);
      }
    } catch (error) {
      setIsInProgress(!isInProgress);
      console.log(error);
    } finally {
      setIsInProgress(false);
    }
  };
  useEffect(() => {

    if (postByIds?.isDeleted === false) {
      const count = comments.filter(
        (usecomment) =>
          usecomment.user_id.id === StudentData.id || !usecomment.isDeleted
      ).length;
      setCommentCount(count);
    } else {
      setCommentCount(0);
    }
  }, [comments, postByIds, StudentData, setCommentCount]);

  return (
    <>
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      <div className="w-full orange-scrollBar">
        {Object.keys(postByIds).length > 0 ? (

          <div
            className="w-full flex gap-2"
            style={{ height: "calc(100vh - 185px)", overflow: "hidden" }}
          >
            <div
              className="w-full orange-scrollBar overflow-y-scroll"
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "white",
              }}
            >
              <div className="both_container w-full">
                <div>
                  {/* <PostImage post={postByIds} commentLength={(comments.filter((usecomment) => usecomment.user_id.id === StudentData.id || !usecomment.isDeleted)).length} /> */}
                  <div
                    className="rounded-3"
                    style={{ border: "2px solid #E5E5E5" }}
                  >
                    <PostImagePopup post={postByIds}
                      commentLength={commentLength} setCommentCount={setCommentCount} comment={comments?.length} />
                    <form onSubmit={handelComment}>
                      <div className="comment_box_container writeComment px-2">
                        <Form.Control
                          type="text"
                          placeholder="Write Your Comment"
                          className="comment_box my-3"
                          value={comment}
                          maxLength={250}
                          onChange={(e) => {
                            // Remove leading spaces
                            const value = e.target.value.replace(/^\s+/, '');
                            setComment(value);
                          }}
                          disabled={postByIds?.isDeleted}
                        />

                        <div className="attact_shear_icon ">
                          {/* <input
                              id="attachFile"
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => setCommentAttach(e.target.files[0])}
                            /> 
                            <label htmlFor="attachFile">
                              <img
                                src="/images/attach.svg"
                                className="comment_attach_Icon"
                                alt="AttachBtn"
                              />
                              {commentAttach && " Attached"}
                             </label> */}

                          <button
                            disabled={isInProgress || postByIds?.isDeleted || (comment === '' && commentAttach === null)}
                            id="submitFile"
                            type="submit"
                            style={{ display: "none" }}
                          ></button>
                          <label htmlFor="submitFile">
                            <img
                              src="/images/send button.svg"
                              className="comment_attach_Icon px-3 py-1 cursor-pointer"
                              alt=""
                            />
                          </label>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div
                      className="d-flex justify-content-between"
                      style={{ display: "50%", margin: "10px 0px" }}
                    >
                      <div className="text-[16px] font-semibold">
                        {/* Comment (
                        {postByIds.isDeleted === false
                          ? (comments.filter(
                            (usecomment) =>
                              usecomment.user_id.id === StudentData.id || !usecomment.isDeleted
                          ).length)
                          : 0}
                        ) */}
                        Comments({comments?.length})
                      </div>
                    </div>
                    <div>
                      {isInProgress && (
                        <img
                          className="comment_loader"
                          src="/gif/LoaderDot.gif"
                          alt=""
                        />
                      )}
                      <button
                        className="refresh"
                        style={{ marginRight: "0px" }}
                        onClick={async () => {
                          const scrollY = window.scrollY;
                          setComments([])
                          setVisibleComments(5);
                          await getPostComme();
                          window.scrollTo(0, scrollY);
                        }}
                      >
                        Refresh
                      </button>
                    </div>
                  </div>
                  <div className="p-0 w-[98%]">
                    <div
                      className={`comment_list_container commentsSection ${isInProgress && `comment_loader_background`

                        }`
                      }
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                      }}
                    >
                      {/* {comments &&
                          comments.length > 0 &&
                        comments
                          .map((data) => (
                            <CommentList
                              key={data.id}
                              setIsCommented={setIsCommented}
                              isCommented={isCommented}
                              setIsInProgress={setIsInProgress}
                              isInProgress={isInProgress}
                              setComments={setComments}
                              currentCommentNumber={currentCommentNumber}
                              setCurrentCommentNumber={setCurrentCommentNumber}
                              filter={filter}
                              setFilter={setFilter}
                              commentData={data}
                              post_id={state.post_id}
                              post={postByIds}
                            />
                          ))} */}
                      {/* Added code for display limited comments */}
                      {
                        <div>
                          {comments.slice(0, visibleComments).map((comment, index) => (
                            <CommentList
                              key={comment.id}
                              setIsCommented={setIsCommented}
                              isCommented={isCommented}
                              setIsInProgress={setIsInProgress}
                              isInProgress={isInProgress}
                              setComments={setComments}
                              currentCommentNumber={currentCommentNumber}
                              setCurrentCommentNumber={setCurrentCommentNumber}
                              filter={filter}
                              setFilter={setFilter}
                              commentData={comment}
                              post_id={post_id}
                              post={postByIds}
                              getPostComme={getPostComme}
                            />
                          ))}

                          {/* View more comments button */}
                          {visibleComments < comments.length && (
                            <span
                              className="view_more_comments"
                              onClick={() => setVisibleComments(visibleComments + 5)}  // Show 5 more comments
                            >
                              View more comments
                            </span>
                          )}

                        </div>}
                    </div>
                  </div>
                </div>

                {/* <div className="col-sm-4 mt-2 channels_box">
            <div className="d-flex flex-column flex-end mb-5 createPost">
              <button
                id="open_post_btn"
                class="btn btn-primary post_to_community_button "
                type="button"
                onClick={(e) => setClickPost(true)}
              >
                Post to community
              </button>
              {isPostCreated && (
                <div
                  style={{ right: "-29px", top: "-59px" }}
                  className=" p-2 post_successfull"
                >
                  <img src="/images/Success.png" alt="" />
                  <span className="post_successfull_message">
                    Your post has been sent for review
                  </span>
                </div>
              )}
            </div>
            <div className="mb-2 d-flex align-items-center justify-content-between channel_createBtn">
              <span className="channel_header mt-3">Channels</span>
            </div>
            <div className="feed_channel_boxs YourChannels orange-scrollBar">
              {communitys &&
                communitys.length > 0 &&
                communitys.map((data) => (
                  <ChannelBox
                    key={data.id}
                    setActive={setActive}
                    setViewFirstInProgress={setViewFirstInProgress}
                    viewFirstInProgress={viewFirstInProgress}
                    communityData={data}
                  />
                ))}
            </div>
          </div> */}
                {/* {clickPost && (
            <CreatePostFirst
              setAllPost={setAllPost}
              setChoosedCommunity={setSelectedCommunity}
              setPostCreatedCount={setPostCreatedCount}
              setIsPostCreated={setIsPostCreated}
              setClickPost={setClickPost}
              clickPost={clickPost}
            />
          )} */}
                {homeScreenWalkThroughPopup && (
                  <CommunityTour
                    setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
                    setStepsEnabled={setStepsEnabled}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <img className="h-48 ml-80 mt-32" src="/gif/LoaderDot.gif" alt="" />
          </>
        )}
      </div>

      {clickCreate && <CreateChannelFirst change={setClickCreate} />}
    </>
  );
};

export default FeedDetail;
